import {
  getSearchFilterOptionAffix,
  subscribeSearchFilterOptionAffix,
} from '@hibro/shared';
import { type ReactNode, useSyncExternalStore } from 'react';

/** Draws the mark a loaded module UI registered for a row that names a person. */
export function SearchPersonAffix({
  personId,
}: {
  personId: string;
}): ReactNode {
  const current = useSyncExternalStore(
    subscribeSearchFilterOptionAffix,
    getSearchFilterOptionAffix,
    () => null,
  );
  if (!current) {
    return null;
  }
  return current({ personId }) as ReactNode;
}
